import React, { useEffect, useState } from "react";
import style from "./navbar.module.scss";
import { withRouter } from "react-router-dom"
import auth from "../../auth";

const Navbar = (props) => {

    const [sideBar, setSideBar] = useState({
        open: false, closeClass: 'sideBarWrapperClosed', items: {
            profile: { name: 'پروفایل', linkName: 'profile', name_en: 'Profile' },
            dashboard: { name: 'داشبورد', linkName: '', name_en: 'Dashboard' },
            channels: { name: 'پنل‌های فروش', linkName: 'channels', name_en: 'Channels' },
            variants: { name: 'تنوع‌ها', linkName: 'variants', name_en: 'Variants' },
            // snappshopvariants: { name: 'تنوع‌های اسنپ‌شاپ', linkName: 'snappshopvariants', name_en: 'snappshopvariants' },
            pricing: { name: 'وضعیت باکس', linkName: 'pricing', name_en: 'Pricing' },
            // snappshop: { name: 'قیمت‌گذاری اسنپ‌شاپ', linkName: 'snappshop', name_en: 'SnappShop' },
            orders: { name: 'سفارشات', linkName: 'orders', name_en: 'orders' },
            cargo: { name: 'محموله‌ها', linkName: 'cargo', name_en: 'Cargo' },
            zitron: { name: 'کنترل موجودی', linkName: 'zitron', name_en: 'zitron' },
            wallet: { name: 'کیف پول', linkName: 'wallet', name_en: 'Wallet' },
            setting: { name: 'تنظیمات', linkName: 'setting', name_en: 'Setting' },
            support: { name: 'پشتیبانی', linkName: 'support', name_en: 'support' }
        }
    })
    useEffect(() => {
        if (sideBar.open) {
            let tmp = sideBar
            tmp.closeClass = 'sideBarCloseAnimation'
            setSideBar({ ...tmp })
        }
    }, [sideBar.open]);

    return <div className={style.wrapper}>
        <div className={style.hamIcon} onClick={() => setSideBar({ ...sideBar, open: !sideBar.open })}></div>
        {sideBar.open
            ?
            <div className={style.sideBarWrapper}>
                <div className={style.innerSideBar}>
                    <div className={style.header}>
                        <div className={style.logoWrapper}>
                            <div className={style.logo}></div>
                            <p className={style.name}>مـوبـیـشـا</p>
                        </div>
                        <div className={style.close} onClick={() => setSideBar({ ...sideBar, open: !sideBar.open })}>e</div>
                    </div>

                    <div className={style.seprator}></div>

                    {Object.keys(sideBar.items).map((navItem, index) => <a
                        key={`${sideBar.items[navItem].name_en}${index}`}
                        href={sideBar.items[navItem].linkName != 'zitron' ? `/${sideBar.items[navItem].linkName}` : `https://www.zitron.ir?utm_source=mobisha&utm_medium=app&utm_campaign=affiliate`}
                        className={style.linkItem}
                    >
                        <p className={style.name}>{sideBar.items[navItem].name}</p>
                        {window.location.pathname == `/${sideBar.items[navItem].linkName}` && <div className={style.activeButton}></div>}
                    </a>)}

                    <a className={style.linkItem} onClick={() => auth.logout()}>
                        <p className={style.name}>خروج</p>
                    </a>
                </div>
            </div>
            :
            <div className={style[sideBar.closeClass]}></div>
        }
    </div>
}

export default withRouter(Navbar);



